module.exports = __webpack_public_path__ + "img/peterson-logo.95ce5f50.png";